import { render, staticRenderFns } from "./EventTable.vue?vue&type=template&id=59ca904f"
import script from "./EventTable.vue?vue&type=script&lang=js"
export * from "./EventTable.vue?vue&type=script&lang=js"
import style0 from "./EventTable.vue?vue&type=style&index=0&id=59ca904f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports